export default { sha: '1048c5d6c095b64e243912173d61ddaee8f04fb4', buildNumber: 'undefined' }
